// Only for A/B testing purposes
// TODO: remove when iterative testing of component is completed. PXREC-2968
export const EXPERIMENT_KEY1 = 'pxrec_related_article';
export const JSON_VARIABLE_KEY = 'localisation';
export const EXPERIMENT_KEY2 = 'pde_monki_brand_exposed_impact';
export const AbEvents = {
    ON_GO_TO_SHOP_THE_SET: 'click_go_to_shop_the_set',
    ON_ATB_RELATED_ARTICLES_CLICK: 'click_pdp_atb_pra_related_article',
    ON_ATF_RELATED_ARTICLES_CLICK: 'click_pdp_pra_add_to_favourites_related_article',
    ON_CLICK_RELATED_ARTICLES: 'click_pdp_pra_item_related_article',
    ON_VIEW_RELATED_ARTICLES: 'view_pdp_pra_related_article',
    ON_ATB_STYLE_WITH_CLICK: 'click_pdp_atb_pra_style_with',
    CLICK_PDP_ATB_PRA_STYLE_WITH_MONKI_ITEM: 'click_pdp_atb_pra_style_with_monki_item',
    ON_ATF_STYLE_WITH_CLICK: 'click_pdp_pra_add_to_favourites_style_with',
    ON_CLICK_STYLE_WITH: 'click_pdp_pra_style_with',
    CLICK_PDP_PRA_STYLE_WITH_MONKI_ITEM: 'click_pdp_pra_style_with_monki_item',
    ON_VIEW_STYLE_WITH: 'view_pdp_pra_style_with',
    VIEW_PDP_PRA_STYLE_WITH_MONKI_ITEM: 'view_pdp_pra_style_with_monki_item',
    ON_ATB_OTHERS_ALSO_BOUGHT_CLICK: 'click_pdp_atb_pra_others_also_bought',
    CLICK_PDP_ATB_PRA_OTHER_ALSO_BOUGHT_MONKI_ITEM: 'click_pdp_atb_pra_other_also_bought_monki_item',
    ON_ATF_OTHERS_ALSO_BOUGHT_CLICK: 'click_pdp_pra_add_to_favourites_others_also_bought',
    ON_CLICK_OTHERS_ALSO_BOUGHT: 'click_pdp_pra_item_others_also_bought',
    CLICK_PDP_PRA_OTHERS_ALSO_BOUGHT_MONKI_ITEM: 'click_pdp_pra_others_also_bought_monki_item',
    ON_VIEW_OTHERS_ALSO_BOUGHT: 'view_pdp_pra_others_also_bought',
    VIEW_PDP_PRA_OTHERS_ALSO_BOUGHT_MONKI_ITEM: 'view_pdp_pra_others_also_bought_monki_item',
    ON_CLICK_PDP_PRA_ITEM: 'click_pdp_pra_item',
    CLICK_PDP_PRA_MONKI_ITEM: 'click_pdp_pra_monki_item',
    ON_VIEW_PDP_PRA_ITEM: 'view_pdp_pra_item',
    VIEW_PDP_PRA_MONKI_ITEM: 'view_pdp_pra_monki_item',
    CLICK_SB_PRA_ITEM: 'click_sb_pra_item',
};
//# sourceMappingURL=optimizelyConstants.js.map